import { createContext, useContext } from 'react';
import { useSelector } from "react-redux";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// Replace with real logic in production
export const AuthProvider = ({ children }) => {
      const { token, profile } = useSelector((state) => state.auth);
  const user = {
    isAuthenticated: token ? true : false,
    role: (profile && profile.roles && profile.roles.length>0 && profile.roles[0].name)?  profile.roles[0].name : '', // Can be 'user', 'mentor', 'dev', etc.
  };

  return (
    <AuthContext.Provider value={user}>{children}</AuthContext.Provider>
  );
};